// removed by extract-text-webpack-plugin
module.exports = {"item":"_3v_7","singleItem":"_1ci6","icon":"_3bSm","text":"-gCQ","itemPrefix":"_1Ac8","arrowItem":"_1Z4r _3v_7","moreItem":"_3F2P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownListItem/DropdownListItem.styl
// module id = 79
// module chunks = 0